import React from 'react';
import { Alert, Typography } from '@mui/material';

import {
	ServiceProviderPaymentConstraints,
	PROVIDER_PAYMENT_DISCLAIMER,
} from '../../helpers/providerPaymentConstraints';

interface ProviderPaymentConstraintsAlertProps {
	constraints: ServiceProviderPaymentConstraints;
}

const ProviderPaymentConstraintsAlert: React.FC<ProviderPaymentConstraintsAlertProps> = ({
	constraints,
}: ProviderPaymentConstraintsAlertProps) => {
	if (!constraints.hasProviderPayments) {
		return null;
	}

	return (
		<Alert severity="warning" sx={{ mb: 2 }}>
			<Typography variant="body2">{PROVIDER_PAYMENT_DISCLAIMER}</Typography>
			<Typography variant="body2" sx={{ mt: 0.5 }}>
				Pagado al proveedor: USD{' '}
				{constraints.totalPaidToProvider.toLocaleString('es-UY', {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2,
				})}
				. El costo del servicio no puede quedar por debajo de ese monto.
			</Typography>
		</Alert>
	);
};

export default ProviderPaymentConstraintsAlert;
